import { render, staticRenderFns } from "./cat_causa.vue?vue&type=template&id=56bbc879&scoped=true&"
import script from "./cat_causa.vue?vue&type=script&lang=js&"
export * from "./cat_causa.vue?vue&type=script&lang=js&"
import style0 from "./cat_causa.vue?vue&type=style&index=0&id=56bbc879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bbc879",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bbc879')) {
      api.createRecord('56bbc879', component.options)
    } else {
      api.reload('56bbc879', component.options)
    }
    module.hot.accept("./cat_causa.vue?vue&type=template&id=56bbc879&scoped=true&", function () {
      api.rerender('56bbc879', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/causas/cat_causa.vue"
export default component.exports